import React, { ReactElement, useState } from 'react';
import styles from './ConnectionAssistantFormStep2.module.less';
import DsnService from '../../services/DsnService';
import AppCodeCard from '../AppCodeCard';
import { Select } from 'antd';
import CcxComponentProps from '../../core/CcxComponent';

interface Props extends CcxComponentProps {
    formData?: any;
    service?: string;
}

export default function ConnectionAssistantFormStep2({
    formData,
    service,
    testId = 'ConnectionAssistantFormStep2',
}: Props): ReactElement {
    const { Option } = Select;

    const [technology, setTechnology] = useState<string>();

    const { account, database, hostPort } = formData;
    const [host, port] = hostPort.split(':');

    const getUsageExample = (targetLanguage: string) => {
        return DsnService.getDsnUsageExample({
            service,
            username: account,
            database,
            hostPort,
            host: host,
            port: port,
            target: targetLanguage,
        });
    };

    const getCodeCardContent = (targetLanguage: string) => {
        return getUsageExample(targetLanguage).map((line: string) => {
            return line === '' ? (
                <br />
            ) : (
                <>
                    {line}
                    <br />
                </>
            );
        });
    };

    const technologies = [
        'dsn',
        'ado.net',
        'jdbc',
        'node.js',
        'odbc',
        'php',
        'php.pdo',
        'php.pear.db',
        'python',
        'ruby',
        'go',
    ];

    const onChange = (e: any) => {
        setTechnology(e);
    };

    return (
        <div
            className={styles.ConnectionAssistantFormStep2}
            data-testid={testId}
        >
            <p>Technology</p>
            <Select
                onChange={onChange}
                data-testid={`${testId}Select`}
                className={styles.ConnectionAssistantFormStep2Select}
                placeholder="Select a host"
                allowClear
            >
                {technologies.map((o: string) => {
                    return (
                        <Option value={o} key={o}>
                            {o.toUpperCase()}
                        </Option>
                    );
                })}
            </Select>

            {technology && (
                <>
                    <p>{technology.toUpperCase()}</p>
                    <AppCodeCard usageExample={getUsageExample(technology)}>
                        {getCodeCardContent(technology)}
                    </AppCodeCard>
                </>
            )}
        </div>
    );
}
